import extend from "../../services/extend";
import device from "../../services/device";

/**
 * @ngdoc directive
 * @name ng.directive:vPopUnder
 * @param vue
 */

export default (vue) => extend(vue, (vue) => {
    return {
        touchHandler: ('ontouchstart' in document.documentElement ? "touchstart" : "click"),
        device: device.detect(),
        model: vue.get('service.pop_under'),
        timeout: 0,
        endpoint: null,
        init() {
            if (!this.device.browser.chrome && this.model && window.location.hash !== '#pwu') {
                vue.intersect(() => {
                    // Add target blank
                    vue.el.setAttribute('target', '_blank');
                    vue.el.setAttribute('href', vue.el.getAttribute('href') + '#pwu');


                    vue.el.addEventListener ( this.touchHandler, () => {
                        clearTimeout(this.timeout);

                        this.timeout = setTimeout(() => {
                            fetch(this.model.dismiss).then((r) => {

                                if ( this.model.channels.hasOwnProperty(vue.exp)) {
                                    this.endpoint = this.model.channels[vue.exp][this.device.mobile ? 'mobile' : 'desktop']['link'];
                                } else {
                                    this.endpoint = this.model.target;
                                }

                                let script = document.createElement("script");
                                script.innerHTML = 'window.location.href = "' + this.endpoint + '";';
                                document.head.appendChild(script);
                            });
                        }, 500);

                    }, {passive: true});

                    // Disable action for swipe
                    vue.el.addEventListener('touchmove', () => {
                        clearTimeout(this.timeout);
                    }, { passive: true });

                });
            }
        },
    }
});